const de = {
  // Navigation & Layout
  nav: {
    kreation: 'Kreation',
    kreationDesc: 'Content-Ideen generieren',
    produktion: 'Produktion',
    produktionDesc: 'Content bearbeiten',
    distribution: 'Distribution',
    distributionDesc: 'Content planen',
    settings: 'Einstellungen',
    settingsDesc: 'Profil & Unternehmen',
    profile: 'Profil',
    logout: 'Abmelden',
    user: 'Benutzer',
    impressum: 'Impressum',
    datenschutz: 'Datenschutz',
    brandUpgraded: 'Dein Markenprofil wurde automatisch auf die neue Brand DNA aktualisiert!',
  },

  // Common / Shared
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    loading: 'Laden...',
    generating: 'Wird generiert...',
    failed: 'Fehlgeschlagen',
    success: 'Erfolgreich',
    error: 'Fehler',
    confirm: 'Bestätigen',
    back: 'Zurück',
    next: 'Weiter',
    search: 'Suchen',
    filter: 'Filtern',
    all: 'Alle',
    none: 'Keine',
    yes: 'Ja',
    no: 'Nein',
    draft: 'Entwurf',
    scheduled: 'Geplant',
    published: 'Veröffentlicht',
    archived: 'Archiviert',
    characters: 'Zeichen',
    words: 'Wörter',
    toasts: {
      deleted: 'Gelöscht',
      undo: 'Rückgängig',
      deleteFailed: 'Löschen fehlgeschlagen',
      restoreFailed: 'Wiederherstellung fehlgeschlagen',
      movedTo: 'Verschoben auf {date}',
      moveFailed: 'Verschieben fehlgeschlagen',
      linkedinApproved: 'Für LinkedIn freigegeben',
      linkedinUnapproved: 'LinkedIn-Freigabe zurückgezogen',
      pinterestApproved: 'Für Pinterest freigegeben',
      pinterestUnapproved: 'Pinterest-Freigabe zurückgezogen',
      genericError: 'Fehler',
      loadContentFailed: 'Fehler beim Laden des Contents',
      contentPiecesCreated: '{n} Content Piece{s} erstellt!',
      contentPiecesGenerated: '{n} Content Piece{s} erfolgreich generiert!',
      generationTakingLonger: '{n} Piece{s} brauchen länger als gewohnt – bitte gleich erneut versuchen. Dein Kontingent wird nicht abgerechnet.',
      allPiecesReady: 'Alle Pieces sind nun fertig.',
      generationSlow: 'Generierung braucht länger als gewohnt – bitte gleich erneut versuchen. Dein Kontingent wird nicht abgerechnet.',
      statusUpdated: 'Status aktualisiert',
      scriptSubmitted: 'Skript zur Video-Generierung aufgegeben',
      approveFailed: 'Freigabe fehlgeschlagen',
      maxImagesPerPost: 'Auf {platform} kann man nur max. {max} {imageWord} pro Beitrag posten. Bitte passe deine Auswahl entsprechend an.',
      imageWordSingular: 'Bild',
      imageWordPlural: 'Bilder',
      uploadFailed: 'Upload fehlgeschlagen',
      approvedWithDrafts: 'Freigegeben + {n} neue Entwürfe erstellt',
      approvedInCalendar: 'Freigegeben und im Kalender gespeichert',
      statusChangeFailed: 'Status-Änderung fehlgeschlagen',
      submitFailed: 'Fehler beim Aufgeben zur Generierung',
      addFailed: 'Fehler beim Hinzufügen',
      tagError: 'Tag-Fehler',
    },
    items: 'Elemente',
    of: 'von',
    noResults: 'Keine Ergebnisse',
    tryAgain: 'Erneut versuchen',
    approve: 'Freigeben',
    duplicate: 'Duplizieren',
    restore: 'Wiederherstellen',
    undo: 'Rückgängig machen',
    regenerate: 'Neu generieren',
    platform: 'Plattform',
    noFolder: 'Kein Ordner',
    max: 'Max.',
    chars: 'Zeichen',
    images: 'Bilder',
    download: 'Herunterladen',
    selected: 'ausgewählt',
    selectAll: 'Alle auswählen',
  },

  // Platforms
  platforms: {
    x: 'X',
    linkedin: 'LinkedIn Beitrag',
    linkedin_artikel: 'LinkedIn Artikel',
    instagram: 'Instagram',
    facebook: 'Facebook',
    pinterest: 'Pinterest',
    medium: 'Medium',
    blog: 'Blogartikel',
    newsletter: 'Newsletter',
    pressemitteilung: 'Pressemitteilung',
    youtube: 'YouTube',
  },

  // Onboarding
  onboarding: {
    loading: 'Laden...',
    alreadyRegistered: 'Bereits registriert? Anmelden',
  },

  // Step 1 — Website Analysis
  step1: {
    title: 'Erzähl uns von deinem Unternehmen',
    subtitle: 'Wir analysieren deine Website und verstehen dein Business.',
    urlPlaceholder: 'Deine Website-URL',
    analyzeBtn: 'Analysieren',
    analyzingTitle: 'Wir analysieren dein Unternehmen...',
    analyzingSubtitle: 'Das kann einen Moment dauern.',
    invalidUrl: 'Bitte gib eine gültige URL ein',
    analysisSuccess: 'Analyse abgeschlossen',
    analysisFailed: 'Analyse fehlgeschlagen',
    resultTitle: 'Analyse abgeschlossen',
    resultSubtitle: 'Hier ist deine umfassende Unternehmens- und Content-Strategie-Analyse.',
    yourCompany: 'Dein Unternehmen',
    industry: 'Branche',
    uspsLabel: 'Alleinstellungsmerkmale (USPs)',
    languageStyle: 'Sprachstil',
    address: 'Ansprache',
    keywords: 'Keywords',
    targetAudiences: 'Zielgruppen',
    audience: 'Zielgruppe',
    marketingGoals: 'Marketing-Ziele',
    channelMix: 'Empfohlener Channel-Mix',
    perWeek: 'x/Woche',
    contentThemes: 'Content-Themen',
    onBrandNote: 'Diese Informationen werden genutzt, um deinen Content immer on-brand zu halten.',
    continueBtn: 'Weiter',
  },

  // Kreation Page
  kreation: {
    title: 'Content-Kreation',
    subtitle: 'Erstelle Content aus KI-generierten Ideen oder eigenen Beschreibungen',
    newContent: 'Neuer Content',
    newContentDesc: 'Beschreibe dein Thema und wähle Plattformen',
    contentIdeas: 'Content-Ideen',
    refreshIdeas: 'Neue Ideen',
    ideasLoaded: 'Neue Ideen geladen',
    ideasFailed: 'Ideen konnten nicht geladen werden',
    ideaRejected: 'Idee abgelehnt',
    actionFailed: 'Aktion fehlgeschlagen',
    generateFromIdea: 'Content aus Idee generiert!',
    generateBtn: 'Content generieren',
    generateIdea: 'Idee generieren',
    editBtn: 'Bearbeiten',
    rejectBtn: 'Ablehnen',
    describeTopic: 'Beschreibe dein Thema oder füge einen Text ein...',
    describeRequired: 'Bitte beschreibe, was du kommunizieren möchtest',
    platformRequired: 'Bitte wähle mindestens eine Plattform aus',
    generationFailed: 'Content-Generierung fehlgeschlagen',
    limitReached: 'Du hast dein monatliches Limit verbraucht. Content-Generierung nicht möglich.',
    limitReachedShort: 'Du hast dein monatliches Limit verbraucht',
    videoLimit: 'Video-Limit erreicht: Sie haben diesen Monat bereits {limit} Videos generiert.',
    selectPlatforms: 'Ausgabeformate',
    imageElement: 'Bildelement',
    hauptprodukt: 'Hauptprodukt',
    markengesicht: 'Markengesicht',
    keepInputText: 'Eigenen Text verwenden',
    keepPhotos: 'Eigene Fotos verwenden',
    uploadFiles: 'Dateien hochladen',
    generating: 'Content wird generiert...',
    contentsGenerated: 'Contents erstellt',
    existingContent: 'Bestehender Content',
    noContent: 'Noch kein Content erstellt',
    toProduction: 'In Produktion',
    tabs: {
      manual: 'Eigener Content',
      ideas: 'KI-Ideen',
    },
    tokenLimitBody: 'Du hast dein Token-Limit verbraucht. Der Verbrauch wird am Monatsanfang zurückgesetzt.',
    togetherCreatedPre: 'Wir haben gemeinsam schon',
    togetherCreatedPost: 'erstellt! Bereit für mehr?',
    refImages: {
      title: 'Referenzbild(er) für diesen Post (Stil) — bis zu 4 wählbar',
      ownTile: 'Eigenes',
      ownAlt: 'Eigenes Referenzbild',
      thumbAlt: 'Referenzbild',
      hintCustom: 'Das generierte Bild orientiert sich an deinem hochgeladenen Referenzbild. Tippe eine andere Kachel, um zu wechseln.',
      hintSelectedOne: 'Das generierte Bild orientiert sich an {n} ausgewählten Referenzbild (max 4).',
      hintSelectedMany: 'Das generierte Bild orientiert sich an {n} ausgewählten Referenzbildern (max 4).',
      hintNone: 'Kein Referenzbild ausgewählt — es werden alle Marken-Referenzen als Stilquelle verwendet.',
    },
    multiLang: {
      hint: 'Mehrere Sprachen = 1 Post in allen Sprachen. Erste = Primär.',
      primary: 'Primär',
    },
    platformsSelected: 'Formate ausgewählt (max. {{max}} für zuverlässige Generierung)',
    ideaPlaceholderPrefix: 'z.B. ',
    describeTopicFallback: 'Beschreibe dein Thema oder füge einen Text ein…',
  },

  // Produktion Page
  produktion: {
      retry: {
        button: 'Erneut versuchen',
        buttonShort: 'Erneut',
        starting: 'Startet…',
        generatingTitle: 'Wird generiert…',
        restarted: 'Generierung wurde neu gestartet.',
        failedAgain: 'Erneuter Versuch fehlgeschlagen — bitte Support kontaktieren.',
        ready: 'Content ist bereit.',
        couldNotStart: 'Erneuter Versuch konnte nicht gestartet werden.',
      },
      imageGen: {
        unknownError: 'unbekannter Fehler',
        failed: 'Bildgenerierung fehlgeschlagen: {msg}. Dein Kontingent wird nicht verbraucht.',
      },
    title: 'Content-Produktion',
    subtitle: 'Bearbeite und verfeinere deinen Content',
    allContent: 'Alle Inhalte',
    drafts: 'Entwürfe',
    scheduled: 'Geplant',
    published: 'Veröffentlicht',
    deleted: 'Gelöscht',
    noContent: 'Kein Content vorhanden',
    noContentDesc: 'Erstelle deinen ersten Content in der Kreation',
    goToKreation: 'Zur Kreation',
    editContent: 'Content bearbeiten',
    regenerateText: 'Text neu generieren',
    regenerateImage: 'Bild neu generieren',
    textRegenerated: 'Text wurde neu generiert',
    imageRegenerated: 'Bild wurde neu generiert',
    regenerationFailed: 'Regenerierung fehlgeschlagen',
    deleteContent: 'Content löschen',
    deleteConfirm: 'Möchtest du diesen Content wirklich löschen?',
    contentDeleted: 'Content gelöscht',
    contentRestored: 'Content wiederhergestellt',
    restore: 'Wiederherstellen',
    schedule: 'Einplanen',
    scheduleContent: 'Content einplanen',
    scheduledSuccess: 'Content eingeplant',
    publishNow: 'Jetzt veröffentlichen',
    saveChanges: 'Änderungen speichern',
    changesSaved: 'Änderungen gespeichert',
    saveFailed: 'Speichern fehlgeschlagen',
    textContent: 'Text-Content',
    headline: 'Überschrift',
    hashtags: 'Hashtags',
    imagePrompt: 'Bild-Prompt',
    pinTitle: 'Pin-Titel',
    pinDescription: 'Pin-Beschreibung',
    videoScript: 'Video-Skript',
    videoTitle: 'Video-Titel',
    videoDescription: 'Video-Beschreibung',
    videoTags: 'Video-Tags',
    pressHeadline: 'Überschrift',
    pressSubtitle: 'Untertitel',
    pressShortText: 'Kurztext',
    pressBodyText: 'Meldungstext',
    pressKeywords: 'Schlüsselwörter',
    pressCompanyDesc: 'Firmenbeschreibung',
    version: 'Version',
    versions: 'Versionen',
    currentVersion: 'Aktuelle Version',
    previousVersions: 'Ältere Versionen',
    contentNumber: 'Content Nr.',
    createdAt: 'Erstellt am',
    lastEdited: 'Zuletzt bearbeitet',
    platform: 'Plattform',
    status: 'Status',
    language: 'Sprache',
    comments: 'Kommentare',
    addComment: 'Kommentar hinzufügen',
    commentPlaceholder: 'Schreibe einen Kommentar...',
    commentAdded: 'Kommentar hinzugefügt',
    noComments: 'Noch keine Kommentare',
    copyText: 'Text kopieren',
    textCopied: 'Text kopiert',
    downloadImage: 'Bild herunterladen',
    fullscreen: 'Vollbild',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    search: 'Suche: Titel, Keywords, #ID...',
    allPlatforms: 'Alle Plattformen',
    select: 'Auswählen',
    folderName: 'Ordnername...',
    createTags: 'Tags erstellen',
    manageTags: 'Tags verwalten',
    newTagName: 'Neuer Tag-Name...',
    noTagsYet: 'Noch keine Tags erstellt',
    deleteCount: 'Löschen',
    postsDeleted: 'Beiträge gelöscht',
    bulkDeleteTitle: 'Bist du sicher?',
    tryDifferentFilters: 'Versuche andere Filter',
    generateImage: 'Bild generieren',
    imageLoading: 'Lädt...',
    expand: 'Vergrößern',
    moveToFolder: 'In Ordner verschieben',
    removeFromFolder: 'Aus Ordner entfernen',
    noFoldersYet: 'Noch keine Ordner erstellt',
    firstComment: 'Füge den ersten Kommentar hinzu',
    videoGenerating: 'Video wird generiert...',
    chooseFromGallery: 'Aus Galerie wählen',
    charactersLabel: 'Zeichen',
    versionsLabel: 'Versionen',
    versionSingular: 'Version',
    versionLoaded: 'Version {n} geladen',
    approveDialogTitle: 'Content freigeben',
    approveDialogQuestion: 'Soll dieser Content auch für eine andere Plattform aufbereitet werden?',
    aiCalculatingTime: 'KI berechnet optimale Posting-Zeit...',
    aiRecommendation: 'KI-Empfehlung',
    dateLabel: 'Datum',
    timeLabel: 'Uhrzeit',
    plannedPublication: 'Geplante Veröffentlichung',
    atTime: 'um {time} Uhr',
    autoPostOn: 'Automatisch bei {platform} posten',
    maxCharsExceeded: 'Auf {platform} kann man nur max. {max} Zeichen pro Beitrag posten. Dein Text hat {count} Zeichen. Bitte kürze deinen Text entsprechend.',
    charsTooMany: '{n} zu viel!',
    aiReasonDefault: 'Optimale Posting-Zeit basierend auf Plattform-Daten.',
    clearSelection: 'Auswahl aufheben',
    fromGallery: 'Aus Galerie',
    scheduledDate: 'Geplantes Datum',
    schedulePost: 'Veröffentlichung planen',
    scheduleInCalendar: 'In Kalender einplanen',
    scheduledInCalendar: 'Im Kalender eingeplant!',
    adaptChannels: 'Für andere Kanäle anpassen?',
    noThanks: 'Nein, danke',
    channelsAdapt: 'Kanäle anpassen',
    selectChannels: 'Kanäle auswählen',
    postAlreadyScheduled: 'Beitrag bereits eingeplant',
    scheduledAt: 'Eingeplant am: ',
    replaceScheduled: 'Eingeplanten Beitrag ersetzen',
    saveAsDraft: 'Änderungen als Entwurf speichern',
    aiRefineText: 'KI-Anweisung — Text anpassen',
    aiRefinePlaceholder: 'z.B. "Kürze auf die Hälfte", "Formeller", "Mehr Emojis"',
    aiGenerateImage: 'KI-Bild generieren',
    aiGenerateImageTitle: 'Eigene Idee? Erstelle mit KI-Anweisung',
    aiGenerateImagePlaceholder: 'z.B. "Hellere Farben", "Mehr Natur", "Minimalistisch"',
    aiRefineImage: 'Bild per KI-Anweisung anpassen',
    saveImages: 'Bilder speichern',
    imagesSaved: 'Bilder gespeichert',
    textRefined: 'Text angepasst!',
    imageGenerated: 'Neues Bild generiert!',
    refinementFailed: 'Anpassung fehlgeschlagen',
    commentFailed: 'Kommentar konnte nicht gepostet werden',
    commentDeleted: 'Kommentar gelöscht',
    tagCreated: 'Tag erstellt',
    tagDeleted: 'Tag gelöscht',
    folderCreated: 'Ordner erstellt',
    folderRenamed: 'Ordner umbenannt',
    folderDeleted: 'Ordner gelöscht',
    movedToFolder: 'In Ordner verschoben',
    removedFromFolder: 'Aus Ordner entfernt',
    saved: 'Gespeichert',
    deleteFailed: 'Löschen fehlgeschlagen',
    restored: 'Wiederhergestellt',
    restoreFailed: 'Wiederherstellen fehlgeschlagen',
    schedulingFailed: 'Einplanung fehlgeschlagen',
    savedAsDraft: 'Als Entwurf gespeichert',
    justNow: 'Gerade eben',
    takeMoment: 'Das kann einen Moment dauern',
    deletePermanently: 'Endgültig löschen',
  },

  // Distribution Page
  distribution: {
    title: 'Content-Distribution',
    subtitle: 'Plane und verwalte deine Content-Veröffentlichungen',
    calendar: 'Kalender',
    list: 'Liste',
    today: 'Heute',
    month: 'Monat',
    week: 'Woche',
    newPost: 'Neuer Post',
    schedulePost: 'Post einplanen',
    scheduledPosts: 'Geplante Posts',
    noScheduled: 'Keine geplanten Posts',
    noScheduledDesc: 'Plane deinen Content über den Kalender',
    publishNow: 'Jetzt veröffentlichen',
    publishSuccess: 'Erfolgreich veröffentlicht',
    publishFailed: 'Veröffentlichung fehlgeschlagen',
    selectDate: 'Datum wählen',
    selectTime: 'Uhrzeit wählen',
    selectContent: 'Content wählen',
    selectBoard: 'Board wählen',
    pinLink: 'Pin-Link',
    connectedAccounts: 'Verbundene Konten',
    noAccounts: 'Keine Konten verbunden',
    connectAccount: 'Konto verbinden',
    syncStatus: 'Sync-Status',
    synced: 'Synchronisiert',
    pending: 'Ausstehend',
    errorSync: 'Sync-Fehler',
    deleteEvent: 'Termin löschen',
    eventDeleted: 'Termin gelöscht',
    eventScheduled: 'Termin erstellt',
    eventUpdated: 'Termin aktualisiert',
    manualPost: 'Manueller Post',
    fromContent: 'Aus Content',
    enterText: 'Text eingeben...',
    characters: 'Zeichen',
    addManualContent: 'Füge manuell erstellten Content zum Kalender hinzu.',
    videoOptional: 'Video (optional, max 100MB)',
    uploadingVideo: 'Video wird hochgeladen...',
    uploadVideo: 'Video hochladen (MP4, MOV, WebM)',
    bestTimeSuggested: 'Beste Zeit vorgeschlagen',
    uploadVideoShort: 'Video hochladen',
    duplicatePost: 'Posting duplizieren',
    postingFailed: 'Posting fehlgeschlagen',
    reschedule: 'Neu planen',
    downloadingVideo: 'Video wird heruntergeladen...',
    platformLabel: 'Plattform',
    dateTime: 'Datum & Uhrzeit',
    duplicateBtn: 'Duplizieren',
    postCreated: 'Posting erstellt',
    postCreateFailed: 'Fehler beim Erstellen',
    changesSaved: 'Änderungen gespeichert',
    saveFailed: 'Speichern fehlgeschlagen',
    provideDatetime: 'Bitte Datum & Uhrzeit angeben',
    duplicated: 'Posting dupliziert',
    duplicateFailed: 'Duplizieren fehlgeschlagen',
    linkedinPosted: 'Auf LinkedIn gepostet!',
    linkedinFailed: 'LinkedIn-Posting fehlgeschlagen',
    pinterestPosted: 'Auf Pinterest gepinnt!',
    pinterestFailed: 'Pinterest-Posting fehlgeschlagen',
    selectPinterestBoard: 'Bitte wähle ein Pinterest-Board aus',
    rescheduledFailed: 'Erneut fehlgeschlagen — bitte prüfe die Fehlermeldung',
    rescheduled: 'Erfolgreich neu geplant!',
    rescheduleFailed: 'Neu planen fehlgeschlagen',
    restored: 'Wiederhergestellt',
    fillRequiredFields: 'Bitte fülle alle Pflichtfelder aus',
    pinTitleRequired: 'Pin-Titel ist erforderlich',
    pinTitleTooLong: 'Pin-Titel darf max. 100 Zeichen haben',
    pinDescTooLong: 'Pin-Beschreibung darf max. 500 Zeichen haben',
    pinImageRequired: 'Pinterest Pins benötigen ein Bild',
    textRequired: 'Text ist erforderlich',
    imagesUploaded: 'Bild(er) hochgeladen',
    imageNotFile: 'ist keine Bilddatei',
    imageTooLarge: 'ist zu groß (max 10MB)',
    uploadFailed: 'Upload fehlgeschlagen',
    maxImages: 'Maximum {{max}} Bilder für diese Plattform',
    onlyVideoAllowed: 'Nur Videodateien erlaubt (MP4, MOV, AVI, WebM)',
    videoTooLarge: 'Video zu groß (max 100MB)',
    videoUploaded: 'Video hochgeladen',
    videoUploadFailed: 'Video-Upload fehlgeschlagen',
    noPosts: 'Keine Posts',
    noPostings: 'Keine Postings',
    pressRelease: 'Pressemitteilung',
    textPlaceholder: 'Dein Posting-Text...',
    dateTimeRequired: 'Datum & Uhrzeit *',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    detail: {
      scheduledFor: 'Geplant für',
      status: 'Status',
      pinTitle: 'Pin-Titel',
      pinDescription: 'Pin-Beschreibung',
      noTitle: 'Kein Titel vorhanden',
      noDescription: 'Keine Beschreibung vorhanden',
      descriptionCopied: 'Beschreibung kopiert!',
      copy: 'Kopieren',
      link: 'Link',
      text: 'Text',
      textCopied: 'Text kopiert!',
      image: 'Bild',
      imagesPlural: 'Bilder ({n})',
      downloadingImages: 'Bilder werden heruntergeladen...',
      download: 'Herunterladen',
      video: 'Video',
      viewInProduction: 'In Produktion ansehen',
      postedToLinkedin: 'Auf LinkedIn gepostet',
      postToLinkedin: 'Auf LinkedIn posten',
      postNow: 'Jetzt posten',
      scheduledShort: 'Geplant',
      atScheduledTime: 'Zum geplanten Zeitpunkt',
      autoPostedAt: 'Wird automatisch am {date} gepostet',
      errorLabel: 'Fehler:',
      postedToPinterest: 'Auf Pinterest gepostet',
      pinterestNeedsImage: 'Pinterest Pins benötigen mindestens ein Bild',
      postToPinterest: 'Auf Pinterest posten',
      edit: 'Bearbeiten',
      duplicate: 'Duplizieren',
      delete: 'Löschen',
      noChannelConnected: 'Für diese Plattform ist noch kein Kanal verbunden.',
      publishFailedGeneric: 'Der Beitrag konnte nicht veröffentlicht werden. Bitte erneut versuchen.',
      errorCodes: {
        media_unreachable: 'Bild oder Video konnte nicht geladen werden. Bitte prüfe die Medien-URL oder lade die Datei neu hoch.',
        aspect_ratio: 'Das Seitenverhältnis des Mediums wird von dieser Plattform nicht unterstützt. Bitte ein passendes Format wählen (z. B. 1:1, 4:5 oder 9:16).',
        media_too_large: 'Die Mediendatei ist zu groß für diese Plattform. Bitte kleinere Datei hochladen.',
        media_unsupported: 'Das Dateiformat wird von dieser Plattform nicht unterstützt.',
        text_too_long: 'Der Text überschreitet das Zeichenlimit dieser Plattform. Bitte kürzen und erneut versuchen.',
        auth_expired: 'Die Verbindung zum Konto ist abgelaufen. Bitte im Bereich «Integrationen» das Konto neu verbinden.',
        insufficient_permissions: 'Dem verbundenen Konto fehlen Berechtigungen für diese Aktion. Bitte im Bereich «Integrationen» neu verbinden und alle Freigaben erteilen.',
        rate_limited: 'Zu viele Anfragen an die Plattform. Bitte in wenigen Minuten erneut versuchen.',
        duplicate_post: 'Dieser Beitrag wurde bereits kürzlich veröffentlicht. Bitte Inhalt leicht anpassen oder Duplikat entfernen.',
        account_missing: 'Das verbundene Konto wurde bei PostPeer nicht gefunden. Bitte die Zuordnung im Admin-Panel prüfen und ggf. neu verbinden.',
        schedule_invalid: 'Der geplante Zeitpunkt ist ungültig oder liegt in der Vergangenheit. Bitte einen neuen Zeitpunkt mit Zeitzone wählen.',
        validation_error: 'Ein erforderliches Feld fehlt oder ist ungültig. Bitte Text, Medien und Termin prüfen.',
        upstream_unavailable: 'Die Plattform ist gerade nicht erreichbar. Bitte in einigen Minuten erneut versuchen.',
        no_channel_connected: 'Für diese Plattform ist noch kein Kanal verbunden.',
        generic: 'Der Beitrag konnte nicht veröffentlicht werden. Bitte erneut versuchen. Wenn das Problem bestehen bleibt, den Support kontaktieren.',
      },
    },
  },

  // Settings Page
  settings: {
    styleStrength: {
      title: 'Stil-Treue zu Referenzen',
      description: 'Wie genau soll das Bild wie deine Referenzen aussehen? Wirkt bei jeder Bildgenerierung.',
      lockerLabel: 'Locker',
      lockerDesc: 'Farbpalette & Stimmung als lockere Inspiration',
      treffenLabel: 'Treffen',
      treffenDesc: 'Am Markenstil bleiben, aber flexibel adaptieren',
      exaktLabel: 'Exakt',
      exaktDesc: 'Referenzen so genau wie möglich reproduzieren',
      saved: 'Stil-Treue gespeichert',
      saveError: 'Fehler beim Speichern der Stil-Treue',
    },
    title: 'Einstellungen',
    subtitle: 'Verwalte dein Profil und Unternehmenseinstellungen',
    tabs: {
      company: 'Unternehmen',
      brand: 'Markenstil',
      channels: 'Kanäle',
      preferences: 'Präferenzen',
    },
    company: {
      name: 'Unternehmensname',
      industry: 'Branche',
      activities: 'Kerntätigkeit',
      targetAudience: 'Zielgruppe',
      usps: 'USPs (Alleinstellungsmerkmale)',
      keywords: 'Keywords',
      save: 'Unternehmensprofil speichern',
      saved: 'Unternehmensprofil gespeichert',
      // audit iter113
      coreBusinessPlaceholder: 'Was macht euer Unternehmen?',
      audiencePlaceholder: 'z.B. B2B Unternehmen, Endverbraucher 25-45',
      industryPlaceholder: 'z.B. Technologie, Gesundheit, E-Commerce',
      addUspPlaceholder: 'Neues USP hinzufügen...',
      companyDataTitle: 'Unternehmensdaten',
      companyDataDesc: 'Analysiere deine Website oder bearbeite die Daten manuell — wird für Content- und Ideengenerierung verwendet',
      urlAnalyzeDesc: 'Gib deine Website-URL ein und starte die Analyse, oder fülle die Felder manuell aus',
      saveChanges: 'Änderungen speichern',
      exampleCountry: 'z.B. Österreich',
    },
    brand: {
      title: 'Markenstil & Brand DNA',
      toneOfVoice: 'Tonalität',
      addressing: 'Ansprache',
      formality: 'Formalität',
      writingStyle: 'Schreibstil',
      characteristics: 'Eigenschaften',
      signatureWords: 'Signatur-Wörter',
      addWord: 'Wort hinzufügen',
      brandSummary: 'Brand Summary',
      doList: "Do's",
      dontList: "Don'ts",
      inspirations: 'Inspirationen',
      addInspiration: 'Inspiration hinzufügen',
      brandMedia: 'Brand-Medien',
      uploadMedia: 'Medien hochladen',
      styleTemplates: 'Stilvorlagen',
      reanalyze: 'Brand DNA neu analysieren',
      analyzing: 'Analyse läuft...',
      analyzed: 'Brand DNA aktualisiert',
      analysisFailed: 'Analyse fehlgeschlagen',
    },
    channels: {
      title: 'Verbundene Kanäle',
      connect: 'Verbinden',
      disconnect: 'Trennen',
      connected: 'Verbunden',
      notConnected: 'Nicht verbunden',
      connectLinkedIn: 'LinkedIn verbinden',
      connectPinterest: 'Pinterest verbinden',
    },
    preferences: {
      title: 'Präferenzen',
      contentLanguage: 'Content-Sprache',
      contentLanguageDesc: 'Standard-Sprache für alle Plattformen. Kann pro Plattform überschrieben werden.',
      imageStyle: 'Bildstil',
      imageStyleDesc: 'Welchen Bildstil bevorzugst du?',
      illustrations: 'Illustrationen',
      aiPeople: 'KI-Menschen',
      photography: 'Fotografie',
      mixed: 'Gemischt',
      saved: 'Präferenzen gespeichert',
      saveFailed: 'Speichern fehlgeschlagen',
    },
    integrationsTab: 'Integrationen',
    personalInfo: 'Persönliche Daten',
    personalInfoDesc: 'Aktualisiere deine Kontoinformationen',
    billing: 'Abrechnung',
    emailImmutable: 'E-Mail kann nicht geändert werden',
    passwordChange: 'Passwort ändern',
    passwordSet: 'Passwort vergeben',
    passwordFirstTimeHint: 'Dein Konto wurde per Magic Link eingerichtet. Lege jetzt ein Passwort fest, um dich auch klassisch anmelden zu können.',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    password: 'Passwort',
    saveChanges: 'Änderungen speichern',
    saving: 'Speichern...',
    companyAnalysis: 'Unternehmensanalyse',
    regenerate: 'Neu generieren',
    brandDnaRegenerated: 'Brand DNA neu generiert',
    brandDnaRegenerateFailed: 'Fehler beim Generieren',
    dnaFieldLabels: {
      usp: 'Alleinstellungsmerkmal',
      market_position: 'Marktposition',
      positioning: 'Positioning',
      product_promise: 'Product Promise',
      address_form: 'Ansprache',
      formality_level: 'Formalitätslevel',
      personality_traits: 'Persönlichkeits-Adjektive',
      dos: "Do's",
      donts: "Don'ts",
      forbidden_phrases: 'Verbotene Phrasen',
      mandatory_elements: 'Pflicht-Elemente',
      headline_words_min: 'Headline Min.',
      headline_words_max: 'Headline Max.',
      body_words_min: 'Body Min.',
      body_words_max: 'Body Max.',
      hashtags_min: 'Hashtags Min.',
      hashtags_max: 'Hashtags Max.',
      posting_frequency: 'Posting-Rhythmus',
      must_use: 'Pflicht-Wörter',
      forbidden: 'Verbotene Wörter',
      brand_terms: 'Marken-Eigenbegriffe',
      headline_font: 'Überschriften-Font',
      body_font: 'Fließtext-Font',
      photo_styles: 'Foto-Stile',
      design_elements: 'Design-Elemente',
      value_proposition: 'Value Proposition',
    },
    dnaDimensions: {
      brand_identity: 'Brand Identity',
      voice_and_tone: 'Voice & Ton',
      copy_rules: 'Schreibregeln',
      copy_metrics: 'Textlängen',
      core_vocabulary: 'Markenwörter',
      visual_identity: 'Visueller Stil',
      content_strategy: 'Content-Strategie & CTAs',
    },
    dnaExtras: {
      colorPalette: 'Farbpalette',
      referenceGood: 'So soll es klingen',
      referenceBad: 'So NICHT',
      notDefined: 'Nicht definiert',
      oneEntryPerLine: 'Ein Eintrag pro Zeile',
      salutationLabel: 'Ansprache',
      uploadBrandManual: 'Brand Manual hochladen',
      uploadBrandManualDesc: 'Lade dein Corporate Design Manual (PDF/DOCX) hoch. Die KI extrahiert alle 7 Dimensionen.',
      uploadPdfOrDocx: 'PDF oder DOCX hochladen',
      uploading: 'Wird hochgeladen...',
      extractingText: 'Text wird extrahiert...',
      analyzingChars: 'KI analysiert {chars} Zeichen...',
      showLegacyManual: 'Legacy Brand Manual anzeigen',
    },
    writing: {
      contentLanguage: 'Content-Sprache',
      contentLanguageDesc: 'Standard-Sprache für alle Plattformen. Kann pro Plattform überschrieben werden.',
      platformMapping: 'Plattform-Zuordnung (optional — leer = Standard)',
      addressingAndTone: 'Ansprache & Ton',
      salutation: 'Ansprache',
      tonality: 'Tonalität',
      tonalityPlaceholder: 'z.B. professionell, warm, direkt',
      formality: 'Formalität',
      formalityFormal: 'formell',
      formalityNeutral: 'neutral',
      formalityInformal: 'informell',
      emojiUsage: 'Emoji-Nutzung',
      emojiNone: 'keine',
      emojiSparingly: 'sparsam',
      emojiModerate: 'moderat',
      emojiPlentiful: 'reichlich',
      emojiFromAnalysis: 'Häufig verwendete Emojis (aus Analyse)',
      phrasesAndPatterns: 'Phrasen & Muster',
      recurringPhrases: 'Wiederkehrende Phrasen',
      recurringPhrasesPh: 'z.B. Wir glauben daran, ...',
      favoriteWords: 'Lieblingswörter',
      favoriteWordsPh: 'z.B. innovativ, nachhaltig',
      postOpenings: 'Post-Eröffnungsmuster',
      postOpeningsPh: 'z.B. Wusstest du schon, ...',
      forbiddenElements: 'Verbotene Elemente',
      forbiddenElementsPh: 'z.B. Clickbait, Ausrufezeichen',
      dosAndDonts: "Do's & Don'ts",
      dosLabel: "Do's — Was immer vorkommen soll",
      dosPh: 'z.B. Mehrwert bieten, konkrete Tipps',
      dontsLabel: "Don'ts — Was niemals vorkommen soll",
      dontsPh: 'z.B. zu werblich, Clickbait',
      saveWriting: 'Schreibstil speichern',
      savedToast: 'Schreibstil gespeichert',
      saveFailed: 'Fehler beim Speichern',
    },
    channels: {
      activeChannels: 'Aktive Kanäle',
      activeChannelsDesc: 'Wähle die Plattformen aus, für die du Content erstellen möchtest. Nur aktive Kanäle erscheinen in Kreation und Produktion.',
      noneActive: 'Noch keine Plattformen aktiviert. Klicke unten um Kanäle auszuwählen.',
      availableChannels: 'Verfügbare Kanäle',
      ownChannels: 'Eigene Kanäle',
      newChannel: 'Neuer Kanal',
      nameRequired: 'Name erforderlich',
      addAtLeastOneField: 'Mindestens ein Feld hinzufügen',
      channelName: 'Kanal-Name',
      channelNamePh: 'z.B. TikTok, Intranet, WhatsApp...',
      fieldsLabel: 'Felder',
      fieldNamePh: 'Feldname (z.B. Titel)',
      max: 'Max:',
      addField: 'Weiteres Feld',
      createChannel: 'Kanal erstellen',
      cancel: 'Abbrechen',
      characterLimits: 'Zeichenlimits',
      characterLimitsDesc: 'Eigene Limits pro Plattform — in Wörtern oder Zeichen. Blog & Newsletter: frei wählbar. Andere: maximal bis zum Plattform-Limit.',
      platform: 'Plattform',
      words: 'Wörter',
      characters: 'Zeichen',
      limit: 'Limit',
      free: 'frei',
      resetTitle: 'Zurücksetzen',
      charsPerWordNote: '1 Wort ≈ 6 Zeichen (Deutsch)',
      saveLimits: 'Limits speichern',
      styleManualsPerPlatform: 'Style Manuals je Plattform',
      styleManualPh: 'Style Manual für {name}... Ton, Struktur, Hashtags, typische Post-Länge',
      customStyleManualPh: 'Style Manual für {name}...',
      notActive: 'Nicht aktiv',
      activateAbove: 'Aktiviere diese Plattform oben, um das Style Manual zu bearbeiten.',
      empty: 'Leer',
      charsBadge: 'Zeichen',
      configSavedToast: 'Plattform-Konfiguration gespeichert',
      limitsSavedToast: 'Zeichenlimits gespeichert',
      manualSavedToast: 'Manual gespeichert',
      saveFailedToast: 'Fehler beim Speichern',
      imageFormatTitle: 'Bildformat',
      imageFormatDesc: 'Gilt für alle ab jetzt neu generierten Bilder dieser Plattform.',
      imageFormatDefault: 'Standard',
      imageFormatPortrait: 'Hochformat',
      imageAspectSavedToast: 'Bildformat gespeichert',
    },
    inspirations: {
      screenshotsCard: 'Screenshots für Brand DNA Analyse',
      screenshotsDesc: 'Screenshots von Posts oder Designs hochladen. Die KI analysiert sie für Schreibstil und Bildsprache.',
      uploading: 'Wird hochgeladen...',
      clickToUpload: 'Klicken zum Hochladen',
      analyzing: 'Analysiere...',
      analyzeFromScreenshots: 'Brand DNA aus Screenshots analysieren',
      textInspirations: 'Text-Inspirationen',
      textInspirationsDesc: 'Beispiel-Posts hinzufügen oder Screenshot-Post hochladen. Die KI erkennt die Plattform automatisch.',
      addTextInspiration: 'Text-Inspiration hinzufügen',
      choosePlatformOpt: 'Plattform wählen (optional)',
      postTextPh: 'Post-Text, Notiz oder Beschreibung...',
      whatILikePh: 'Was gefällt mir daran? (optional)',
      addInspiration: 'Inspiration hinzufügen',
      uploadScreenshotOfPost: 'Screenshot eines Posts hochladen',
      aiExtracts: 'Die KI extrahiert den Text und erkennt die Plattform automatisch.',
      analyzingImage: 'Wird analysiert...',
      uploadScreenshot: 'Screenshot hochladen',
      inspirationsCount: 'Inspirationen',
      showLess: 'Weniger anzeigen',
      showMore: '{n} weitere anzeigen',
      showPreviousUploads: '{n} vorherige Uploads anzeigen',
      saveInspirations: 'Inspirationen speichern',
    },
    dnaSummaries: {
      words: 'Wörter',
      mustUse: 'Pflicht',
      forbidden: 'verboten',
      themes: 'Themen',
    },
    products: {
      mainProduct: 'Hauptprodukt / Markengesicht',
      mainProductDesc: 'Wird als visuelle Referenz bei der Bildgenerierung verwendet.',
      imageGenReference: 'Bildgenerierung-Referenz',
      person: 'Person / Markengesicht',
      product: 'Produkt',
      brandFaceBadge: 'Markengesicht',
      productBadge: 'Produkt',
      activeAsReference: '✓ Aktiv als Bildgenerierung-Referenz',
      productNamePh: 'Produktname (optional)',
      personNamePh: 'Name der Person',
      shortDescPh: 'Kurzbeschreibung (optional)',
      rolePositionPh: 'Rolle / Position',
      uploadingText: 'Wird hochgeladen...',
      uploadPhoto: 'Foto hochladen',
      uploadProductImage: 'Produktbild hochladen',
      productNameRequired: 'Produktname *',
      descriptionOptional: 'Beschreibung (optional)',
      addProduct: 'Produkt hinzufügen',
      saveProducts: 'Produkte speichern',
    },
    advanced: {
      seoTitle: 'SEO — Klassische Suchmaschinenoptimierung',
      seoDesc: 'Optimiert Content für Google und andere Suchmaschinen.',
      seoEnabled: 'SEO-Optimierung aktiviert',
      seoEnabledDesc: 'Alle SEO-Features ein- oder ausschalten',
      keywordsEnabled: 'Keywords natürlich einbauen',
      keywordsEnabledDesc: 'Relevante Suchbegriffe fließend im Text verwenden',
      metaEnabled: 'Meta-Titel & Meta-Description',
      metaEnabledDesc: 'Nur für Blog- und Newsletter-Content',
      ctaEnabled: 'Call-to-Action einbauen',
      ctaEnabledDesc: 'Klare Handlungsaufforderungen am Ende jedes Posts',
      geoTitle: 'GEO — Generative Engine Optimization',
      geoDesc: 'Optimiert Content damit KI-Systeme wie ChatGPT, Perplexity und AI Overviews ihn zitieren.',
      geoEnabled: 'GEO-Optimierung aktiviert',
      geoEnabledDesc: 'Alle GEO-Features ein- oder ausschalten',
      citableFacts: 'Zitierfähige Fakten & Autoritätssignale',
      citableFactsDesc: 'Konkrete Zahlen, Studien und Expertenwissen einbauen',
      faq: 'Direkte Fragen beantworten (FAQ-Stil)',
      faqDesc: 'Häufige Fragen direkt und klar beantworten',
      lists: 'Strukturierte Listen für KI-Extraktion',
      listsDesc: 'Klare Aufzählungen die KI-Systeme leicht extrahieren können',
      localSeo: 'Lokale SEO',
      localSeoDesc: 'Für lokale Keyword-Optimierung — optional, nur wenn relevant.',
      city: 'Stadt',
      region: 'Region',
      country: 'Land',
      cityPh: 'z.B. Wien',
      regionPh: 'z.B. Wien',
      saveSettings: 'Einstellungen speichern',
      savedToast: 'Einstellungen gespeichert',
      saveFailed: 'Fehler beim Speichern',
      refreshImageUrlsTitle: 'Bild-URLs erneuern',
      refreshImageUrlsDesc: 'Falls Bilder nicht mehr angezeigt werden (abgelaufene Links).',
      refresh: 'Erneuern',
      refreshedToast: 'Alle Bild-URLs wurden erneuert!',
      refreshFailedToast: 'Fehler beim Erneuern',
    },
    integrations: {
      title: 'Integrationen',
      description: 'Verbinde deine Social-Media-Accounts für direktes Posting',
      connected: 'Verbunden',
      notConnected: 'Nicht verbunden',
      connect: 'Verbinden',
      disconnect: 'Trennen',
      hint: 'Hinweis:',
      disconnectWarning: 'Warnung — {platform} trennen?',
      pendingPostsWarning: '{count} geplante Post{s} verweisen auf diesen Account.',
      afterDisconnect: 'Nach dem Trennen werden diese Posts nicht mehr live gehen, bis du einen neuen Account bindest.',
      cancel: 'Abbrechen',
      disconnectAnyway: 'Trotzdem trennen',
      refreshImageUrlsIntTitle: 'Bild-URLs erneuern',
      refreshImageUrlsIntDesc: 'Falls Bilder in geplanten Posts nicht mehr laden (abgelaufene S3-Links)',
      refreshUrls: 'URLs erneuern',
      refreshUrlsSuccess: 'Alle Bild-URLs wurden erfolgreich erneuert (30 Tage gültig)!',
      refreshUrlsFailed: 'Fehler beim Erneuern der URLs',
      prereqs: {
        instagram: 'Instagram muss ein Business- oder Creator-Konto sein (mit Facebook-Seite verknüpft). Persönliche IG-Konten können nicht posten.',
        facebook: 'Nur Facebook-Seiten (nicht persönliche Profile) können posten. Du musst Admin der Seite sein.',
        tiktok: 'TikTok Business/Creator-Konto empfohlen — persönliche Accounts unterliegen strengeren API-Limits.',
        youtube: 'Der YouTube-Kanal muss verifiziert sein, um Uploads via API zu erlauben.',
        pinterest: 'Pinterest Business-Konto empfohlen — sonst sind manche Post-Typen eingeschränkt.',
      },
    },
    visual: {
      imageStyle: 'Bildstil',
      imageStyleDesc: 'Bestimmt den visuellen Stil deiner generierten Bilder.',
      styleIllustrations: 'Illustrationen',
      styleIllustrationsDesc: 'Digital, Flat Design',
      styleAiPeople: 'KI-Fotos mit Menschen',
      styleAiPeopleDesc: 'Realistisch generierte Fotos',
      stylePhotography: 'Fotografien',
      stylePhotographyDesc: 'Professionelle Foto-Ästhetik',
      styleMixed: 'Gemischt',
      styleMixedDesc: 'Je nach Content-Thema',
      brandColorsAndMood: 'Markenfarben & Stimmung',
      brandColorsDesc: 'Aus der Brand DNA-Analyse. Werden beim Bildgenerieren berücksichtigt.',
      primaryColors: 'Primärfarben',
      colorNamePlaceholder: 'Farbname (optional)',
      visualMood: 'Visuelle Stimmung',
      moodPlaceholder: 'z.B. minimalistisch, warm, modern',
      saveColorsAndMood: 'Farben & Stimmung speichern',
      imagerySaved: 'Bildsprache gespeichert',
      saveFailed: 'Fehler beim Speichern',
      logoOverlay: 'Logo Overlay',
      logoOverlayDesc: 'Logo wird automatisch auf jedes generierte Bild gesetzt.',
      logoOverlayActive: 'Logo Overlay aktiv',
      logoLabel: 'Logo (PNG mit Transparenz empfohlen)',
      clickXToReplace: 'Erst × klicken um Logo zu ersetzen',
      uploadLogo: 'Logo hochladen',
      removeLogoTitle: 'Logo entfernen',
      placeLogo: 'Logo platzieren (ziehen & Größe ändern)',
      bgBlack: 'Schwarz',
      bgWhite: 'Weiß',
    },
  },

  // Language names
  languages: {
    de: 'Deutsch',
    en: 'English',
  },

  // Toast messages
  toast: {
    savingSuccess: 'Erfolgreich gespeichert',
    savingError: 'Speichern fehlgeschlagen',
    networkError: 'Netzwerkfehler — bitte versuche es erneut',
    unauthorized: 'Sitzung abgelaufen — bitte erneut anmelden',
    serverError: 'Serverfehler — bitte versuche es später',
    copied: 'In die Zwischenablage kopiert',
  },
};

export default de;